var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-lightbox.ts
import { BreakPoint, windowSize } from "@adornis/base/client/frontend-helpers/window-size.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { ComponentSizeController } from "@adornis/chemistry/controllers/component-size-controller.js";
import { WindowSizeController } from "@adornis/chemistry/controllers/window-size-controller.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { intrinsicHeight } from "@adornis/chemistry/viewport.js";
import { XPlainDialog } from "@adornis/dialog/x-plain-dialog.js";
import "@adornis/file-utils/db/files.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import { map } from "rxjs/operators";
import { Region } from "westures";
import { MAX_V, MULTI, WesturesInteractable } from "./interactable.js";
import "./x-swipe.js";
import "./x-swipe.js";
var XLightbox = class extends XPlainDialog {
  constructor() {
    super(...arguments);
    this.files = [];
    this.startingIndex = null;
    this.xToClose = true;
    this.titleToShow = "";
    this.hideIndex = false;
  }
  static get element_name() {
    return "x-lightbox";
  }
  getInnerWrapper(options) {
    const { draggable } = options;
    const wrapperElem = super.getInnerWrapper(options);
    if (!draggable)
      wrapperElem.style.setProperty("max-height", "100vh");
    return wrapperElem;
  }
  getContentWrapper(options) {
    const contentWrapper = super.getContentWrapper(options);
    contentWrapper.style.setProperty("height", options.draggable ? "calc(100% - 2.2em)" : "100%");
    contentWrapper.style.setProperty("margin-top", options.draggable ? "2.2em" : null);
    contentWrapper.style.setProperty("max-height", options.draggable ? "100vh" : null);
    return contentWrapper;
  }
  render() {
    if (!this.files)
      return nothing;
    if (!this.xToClose)
      return html`
        <x-lightbox-container
          @done=${() => this.close()}
          .titleToShow=${this.titleToShow}
          .files=${this.files}
          .index=${this.startingIndex}
          ?hideIndex=${this.hideIndex}
        ></x-lightbox-container>
      `;
    return html`
      <x-flex ${css({ position: "relative" })}>
        <x-flex
          padding="md"
          ${css({
      top: `calc( env(safe-area-inset-top) + ${this.spacing.xs} )`,
      right: this.spacing.xs,
      position: "absolute",
      cursor: "pointer",
      zIndex: "6"
    })}
          @click=${() => this.cancel()}
        >
          <x-icon
            ${css({
      color: "white",
      fontSize: "25px"
    })}
          >
            close
          </x-icon>
        </x-flex>

        <x-lightbox-container
          @done=${() => this.close()}
          .files=${this.files}
          .titleToShow=${this.titleToShow}
          .index=${this.startingIndex}
          ?hideIndex=${this.hideIndex}
        ></x-lightbox-container>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], XLightbox.prototype, "files", 2);
__decorateClass([
  state()
], XLightbox.prototype, "startingIndex", 2);
__decorateClass([
  property({ type: Boolean })
], XLightbox.prototype, "xToClose", 2);
__decorateClass([
  state()
], XLightbox.prototype, "titleToShow", 2);
__decorateClass([
  property({ type: Boolean })
], XLightbox.prototype, "hideIndex", 2);
XLightbox = __decorateClass([
  customElement("x-lightbox")
], XLightbox);
var XLightboxContainer = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => [{ ":host": { height: "100%" } }];
    this.files = [];
    this.index = -1;
    this.titleToShow = "";
    this.hideIndex = false;
    this.isDesktop = new RXController(this, windowSize.pipe(map(({ device }) => device >= BreakPoint.desktopSmall)));
    this.size = new WindowSizeController(this, { debounceTime: 200 });
  }
  render() {
    if (!this.files)
      return nothing;
    return html`
      <x-flex
        class="wrapper"
        center
        crossaxis-center
        ${css({
      width: "100vw",
      height: "100vh",
      position: this.isDesktop.value ? "relative" : "static"
    })}
      >
        ${this.isDesktop.value ? html`
              <x-flex
                horizontal
                crossaxis-center
                space-between
                ${css({ height: "100%", position: "absolute", left: "0", top: "0", zIndex: "5" })}
                padding="sm"
              >
                ${this.index <= 0 ? html`<div></div>` : html`
                      <x-icon
                        ${css({ color: "white", fontSize: "50px", cursor: "pointer", userSelect: "none" })}
                        @click=${() => {
      this._xSwipe?.back();
    }}
                      >
                        chevron_left
                      </x-icon>
                    `}
              </x-flex>
            ` : nothing}

        <x-swipe
          @currentSlide-changed=${(e) => {
      this.index = e.detail.value;
    }}
          .currentSlide=${this.index || 0}
          .noswipe=${this.isDesktop.value}
          .hidedots=${this.files.length <= 1}
          ${ref((xSwipe) => {
      if (xSwipe && this._xSwipe !== xSwipe) {
        this._xSwipe = xSwipe;
        if (!this._region)
          this._region = new Region(this._xSwipe);
      }
    })}
          ${css({ maxWidth: "100vw" })}
        >
          ${repeat(this.files ?? [], (file, i) => {
      return html`
              <x-flex
                crossaxis-center
                center
                ${css({
        height: intrinsicHeight.getValue() + "px",
        width: "100vw",
        overflow: "visible",
        position: "relative"
      })}
              >
                <x-flex
                  ${css({ width: "100%", height: "100%", position: "absolute", zIndex: "1" })}
                  @click=${(e) => {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("done"));
      }}
                ></x-flex>

                <x-flex
                  crossaxis-center
                  ${css({
        position: "relative",
        height: "100%",
        zIndex: "4",
        width: this.size.mobile ? "100vw" : ""
      })}
                >
                  ${!Array.isArray(file) && file.meta?.extension === "mp4" ? html` <video autoplay .src=${i === this.index ? file.getServeLink() : null}></video> ` : !Array.isArray(file) && file.meta?.extension === "mp3" ? html`
                        <audio
                          autoplay
                          controls
                          .src=${i === this.index ? file.getServeLink() : null}
                          ${css({ width: "60vw" })}
                        ></audio>
                      ` : html`
                        <x-lightbox-item
                          flex
                          .titleToShow=${this.titleToShow + this.index}
                          .sources=${this.loadMultipleSrc(file, i, this.index)}
                          .region=${this._region}
                          ?hideIndex=${this.hideIndex}
                          .lockDirection=${this._getLockDirection(i)}
                          @item-swipe=${(e) => {
        if (e.detail.direction > 0)
          this._xSwipe?.back();
        else
          this._xSwipe?.forward();
      }}
                        ></x-lightbox-item>
                      `}
                </x-flex>
              </x-flex>
            `;
    })}
        </x-swipe>

        ${this.isDesktop.value ? html`
              <x-flex
                horizontal
                crossaxis-center
                space-between
                ${css({ height: "100%", position: "absolute", right: "0", top: "0", zIndex: "5" })}
                padding="sm"
              >
                ${this.index >= this.files.length - 1 ? html`<div></div>` : html`
                      <x-icon
                        ${css({ color: "white", fontSize: "50px", cursor: "pointer", userSelect: "none" })}
                        @click=${() => {
      this._xSwipe?.forward();
    }}
                      >
                        chevron_right
                      </x-icon>
                    `}
              </x-flex>
            ` : nothing}
      </x-flex>
    `;
  }
  _getLockDirection(i) {
    const isFirst = i === 0;
    const isLast = i === this.files.length - 1;
    if (isFirst && isLast)
      return 2;
    if (isFirst)
      return -1;
    if (isLast)
      return 1;
    return 0;
  }
  // avoid loading images that don't need to be loaded
  loadMultipleSrc(files, i, currIndex) {
    if (!Array.isArray(files))
      files = [files];
    if (i === currIndex || i === currIndex - 1 || i === currIndex + 1) {
      return files.map((f) => f.getServeLink());
    }
    return [];
  }
};
__decorateClass([
  state()
], XLightboxContainer.prototype, "files", 2);
__decorateClass([
  state()
], XLightboxContainer.prototype, "index", 2);
__decorateClass([
  state()
], XLightboxContainer.prototype, "titleToShow", 2);
__decorateClass([
  property({ type: Boolean })
], XLightboxContainer.prototype, "hideIndex", 2);
__decorateClass([
  state()
], XLightboxContainer.prototype, "isDesktop", 2);
__decorateClass([
  state()
], XLightboxContainer.prototype, "size", 2);
__decorateClass([
  state()
], XLightboxContainer.prototype, "_region", 2);
XLightboxContainer = __decorateClass([
  customElement("x-lightbox-container")
], XLightboxContainer);
var XLightboxItem = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.hasLoaded = false;
    this.titleToShow = "";
    this.hideIndex = false;
    this.sources = [];
    this.lockDirection = 0;
    this.size = new ComponentSizeController(this, { debounceTime: 200 });
    this.windowSize = new WindowSizeController(this, { debounceTime: 200 });
  }
  render() {
    return html`
      <style>
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      </style>

      <x-flex
        crossaxis-center
        center
        ${css({
      position: "relative",
      overflow: "hidden",
      height: "100%",
      width: this.windowSize.mobile ? "100vw" : ""
    })}
      >
        <x-flex
          space="xl"
          ${css({
      border: "4px solid white",
      borderTop: `4px solid grey`,
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      animation: "spin 2s linear infinite",
      position: "absolute",
      display: this.hasLoaded ? "none" : "flex"
    })}
        >
        </x-flex>
        <x-flex flex center>
          <x-flex
            ${ref((e) => {
      if (!this._interactable && this.size.width && this.size.height && e)
        this._interactable = new WesturesLightboxInteractable({
          element: e,
          region: this.region,
          lockDirection: this.lockDirection,
          size: {
            width: this.size.width,
            height: this.size.height,
            containerHeight: intrinsicHeight.getValue()
          },
          transformTop: this.sources.length > 1
        }).addPan().addPinch().addTap({ numTaps: 2 }).addSwipe((i, data) => {
          if (Math.abs(data.velocityX) > Math.abs(data.velocityY)) {
            this.dispatchEvent(
              new CustomEvent("item-swipe", { detail: { direction: Math.sign(data.velocityX) } })
            );
          }
        });
    })}
          >
            ${repeat(this.sources, (src) => {
      if (!src)
        return nothing;
      return html`
                <x-image
                  .value=${src}
                  disabled
                  mode="contain"
                  ${css({ width: "80vw", height: "80vh", opacity: this.hasLoaded ? "1" : "0" })}
                  @load=${() => this.hasLoaded = true}
                >
                </x-image>
              `;
    })}
          </x-flex>
        </x-flex>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], XLightboxItem.prototype, "hasLoaded", 2);
__decorateClass([
  state()
], XLightboxItem.prototype, "titleToShow", 2);
__decorateClass([
  property({ type: Boolean })
], XLightboxItem.prototype, "hideIndex", 2);
__decorateClass([
  state()
], XLightboxItem.prototype, "sources", 2);
__decorateClass([
  state()
], XLightboxItem.prototype, "region", 2);
__decorateClass([
  state()
], XLightboxItem.prototype, "lockDirection", 2);
__decorateClass([
  state()
], XLightboxItem.prototype, "size", 2);
__decorateClass([
  state()
], XLightboxItem.prototype, "windowSize", 2);
XLightboxItem = __decorateClass([
  customElement("x-lightbox-item")
], XLightboxItem);
var WesturesLightboxInteractable = class extends WesturesInteractable {
  constructor({
    element,
    region,
    lockDirection = 0,
    size,
    transformTop
  }) {
    super({ element, region });
    this.zooming = false;
    this.lockDirection = lockDirection;
    this.offset = { x: 0, y: Math.max(0, (this.element.offsetHeight - size.containerHeight) / 2) };
    this.size = { width: size.width, height: size.height };
    this.element.style.transformOrigin = transformTop ? "top center" : "center";
  }
  zoom(scale) {
    this.scale = Math.max(1, scale);
    this.zooming = this.scale > 1;
    if (!this.zooming) {
      this.x = 0;
      this.y = 0;
    }
  }
  ensureCenter() {
    if (this.centerTimeout)
      clearTimeout(this.centerTimeout);
    this.centerTimeout = setTimeout(() => {
      this.x = 0;
      this.y = 0;
      this.update_fn();
    }, 500);
  }
  addTap(options) {
    return super.addTap(() => this.zoom(this.scale < 1.5 ? this.scale * 2 : 1), options);
  }
  addPan(options) {
    return super.addPan((i, data) => {
      if (this.zooming) {
        this.x += data.translation.x / this.scale;
        this.y += data.translation.y / this.scale;
      } else if (!this.lockDirection || Math.sign(data.translation.x) === this.lockDirection) {
        this.x += data.translation.x / this.scale;
        this.ensureCenter();
      }
    }, options);
  }
  addSwipe(callback, options) {
    return super.addSwipe((i, data) => {
      if (this.zooming)
        return;
      data.velocity = Math.min(MAX_V, data.velocity);
      data.velocityX = data.velocity * Math.cos(data.direction) * MULTI;
      data.velocityY = data.velocity * Math.sin(data.direction) * MULTI;
      this.ensureCenter();
      callback(this, data);
    }, options);
  }
  addPinch(options) {
    return super.addPinch((i, data) => this.zoom(this.scale * data.scale), options);
  }
};
export {
  XLightbox,
  XLightboxContainer,
  XLightboxItem
};
